<style lang="scss">
  .flip-card {
    background-color: transparent;
    width: 100%;
    max-width: 800px;
    perspective: 1000px;

    &.active {
      .flip-card-inner {
        transform: rotateY(180deg);

        .flip-icon{
          @include positioningOffset(absolute, 10px, unset, unset, 10px);
        }
      }
    }

    .flip-card-inner {
      position: relative;
      width: 100%;
      height: 100%;
      min-height: 500px;
      transition: transform 0.6s;
      transform-style: preserve-3d;
      box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
      // background-color: #D9D9D9;
      border-radius: 10px;

      .flip-icon{
        @include positioningOffset(absolute, 10px, 10px, unset, unset);
        @include flex(50px, flex, center, center);
        z-index: 1;
        color: white;
        font-size: 22pt;
        padding: 5px;
        background-color: rgba(0,0,0,0.4);
        height: 50px;
        border-radius: 10px;
      }

      .flip-card-front, .flip-card-back {
        position: absolute;
        width: 100%;
        height: 100%;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
      }

      #postcard-message {
        max-height: 400px;
        overflow-y: auto;
      }

      .flip-card-front {
        height: 100%;
        width: 100%;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .flip-card-back {
        transform: rotateY(180deg);
      }
    }
  }
</style>

<template>
  <article class="flip-card pointer" @click="active = !active" :class="{'active': active || backOnly}">
    <div class="flip-card-inner">
      <span v-if="!backOnly" class="flip-icon pointer"><i class="fas fa-undo"></i></span>
      <b-card class="flip-card-front p-2">
        <img :src="post.image_url" alt="">
      </b-card>
      <b-card class="flip-card-back p-2">
        <div class="row">
          <section class="col-8">
            <p id="postcard-message" v-html="message"></p>
          </section>
          <section class="col-4">
            <img width="100%" height="auto" src="~@/assets/images/postcard/royal-mail.png" alt="">
            <section class="mb-1 mt-3" v-if="prison.address && post.post_type === 'Physical'">
              <p cy="card-name" class="mb-0"><b>{{post.contact.firstname}} {{post.contact.lastname}}</b></p>
              <p cy="card-address1" class="mb-0">{{prison.address.address1}}</p>
              <p cy="card-address2" class="mb-0">{{prison.address.address2}}</p>
              <p cy="card-address3" class="mb-0" v-if="prison.address.address3">{{prison.address.address3}}</p>
              <p cy="card-city" class="mb-0">{{prison.address.city_town}}</p>
              <p cy="card-country" class="mb-0">{{prison.address.country}}</p>
              <p cy="card-region" class="mb-0">{{prison.address.region}}</p>
              <p cy="card-postcode" class="mb-0">{{prison.address.zip_postal_code}}</p>
            </section>
            <p v-if="post.post_type === 'Digital'">This is a <b>digital</b> piece of post.</p>
            <p cy="card-prisoner-number">{{'prisoner' | term(true)}} Number <b class="d-block">{{post.prisoner_number}}</b></p>
          </section>
        </div>
      </b-card>
    </div>
  </article>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    components: {},
    props: {
      post: {
        required: true,
        type: Object,
      },
      backOnly: {
        required: false,
        default: false,
        type: Boolean,
      },
    },
    data() {
      return {
        active: false,
      };
    },
    computed: {
      ...mapState({
        highlightedPhrase: state => state.postCard.highlightedPhrase,
        prison: state => state.auth.user.prison,
        message: state => state.postCard.postcardMessage,
      }),
    },
    watch: {
      highlightedPhrase() {
        this.highlightKeyPhrase();
      },
      message() {
        this.scrollIntoView();
      },
    },
    beforeDestroy() {
      this.$store.commit('postCard/SET_HIGHLIGHTED_PHRASE', ''); // remove hightlight
    },
    mounted() {

    },
    methods: {
      highlightKeyPhrase() {
        if (this.highlightedPhrase) {
          const searchText = this.highlightedPhrase;
          const regex = new RegExp(searchText, 'gi');
          let text = this.message;

          text = text.replace(/(<mark class="highlight">|<\/mark>)/gim, '');
          this.$store.commit('postCard/SET_ACTIVE_MESSAGE', text.replace(regex, '<mark class="highlight">$&</mark>'))
          this.scrollIntoView();
        }
      },
      scrollIntoView() {
        const card = document.querySelector('.flip-card');
        card.scrollIntoView(false);
        this.active = true; // flip the card to show text
      },
    },
  };
</script>
